// Monkey-patch JavaScript context to contain all EcmaScript 5, 6 methods
// that can be faithfully emulated with a legacy JavaScript engine, e.g. IE
import ReactOnRails from 'react-on-rails';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faClock,
  faCaretDown,
  faTrash,
  faExclamationTriangle,
  faTimes,
  faMapMarker,
  faPhone,
  faCalendar,
} from '@fortawesome/free-solid-svg-icons';

import ActivityWidgetContainer from '../widgets/container/ActivityWidgetContainer';
import AppointmentWidgetContainer from '../widgets/container/AppointmentWidgetContainer';
import UpcomingEventWidgetContainer from '../widgets/container/UpcomingEventWidgetContainer';
import ReservationWidgetContainer from '../widgets/container/ReservationWidgetContainer';
import CourseWidgetContainer from '../widgets/container/CourseWidgetContainer';
import RentalWidgetContainer from '../widgets/container/RentalWidgetContainer';
import CalendarWidgetContainer from '../widgets/container/CalendarWidgetContainer';
import ClassWidgetContainer from '../widgets/container/ClassWidgetContainer';

library.add(faClock, faCaretDown, faExclamationTriangle, faTrash, faTimes, faMapMarker, faPhone, faCalendar);

ReactOnRails.register({
  ActivityWidgetContainer,
  AppointmentWidgetContainer,
  UpcomingEventWidgetContainer,
  ReservationWidgetContainer,
  CourseWidgetContainer,
  RentalWidgetContainer,
  CalendarWidgetContainer,
  ClassWidgetContainer
});
